// @ts-nocheck e961b50d
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_Hline'],
      sections: [
        addPanel.sections.getSections().vectorShape.horizontalLinesSection,
      ],
    };
  },
};
